import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../../../../../../consts";

import { FlexContainers, WrapperContainer } from "../../../../../../../../components";
import { SimpleListSection } from "./SimpleListSection";

export const SimpleListPreview = ({ releaseNotes }) => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      width={"100%"}
      gap={16}
      p={24}>
      {releaseNotes?.features?.length && (
        <SimpleListSection title={strCode.NEW_FEATURES_TITLE} listItems={releaseNotes?.features} />
      )}

      {releaseNotes?.improvements?.length && (
        <SimpleListSection
          title={strCode.IMPROVEMENTS_TITLE}
          listItems={releaseNotes?.improvements}
        />
      )}
    </WrapperContainer>
  );
};

SimpleListPreview.propTypes = {
  releaseNotes: PropTypes.shape({
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    improvements: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};
